import type { FC, SVGProps } from 'react';

import CloseIconSvg from './close.svg';

/** Иконка крестика закрытия. */
const CloseIcon: FC<SVGProps<SVGSVGElement>> = CloseIconSvg;

export default CloseIcon;
